import { Module } from 'vuex'
import { RootState } from '../types'
import { DoctorState } from './types'
import { state } from './state'
import { mutations } from './mutations'
import { actions } from './actions'
import { getters } from './getters'

export const doctor: Module<DoctorState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
